export default __webpack_public_path__ + "static/media/logo-telemedicine-5.e02e43b3.svg";